import { DrawerProps, default as MuiDrawer } from '@mui/material/Drawer'

export type { DrawerProps }

const Drawer = (props: DrawerProps) => {
  return <MuiDrawer {...props} />
}

export default Drawer
